<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header"></div>
            <div class="row justify-content-center">
              <div class="card-title">Exportar Reservas de Sala de Reunião</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="card-body">
                  <div class="row justify-content-center">
                    <div class="col-md-5 mb-3 centered">
                      <label>Escolha a empresa:</label>
                      <select
                        v-model="company_id"
                        class="form-control"
                        id="selectEmpr"
                      >
                        <option
                          v-for="company in companies"
                          :value="company.id"
                          :key="company.id"
                        >
                          {{ company.company_name_fantasy }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <form
                        :action="
                          $store.state.url +
                          'export/rooms/' +
                          company_id +
                          '/' +
                          hash
                        "
                        id="export"
                      >
                        <div class="row justify-content-center">
                          <div class="col-md-5 centered">
                            <button
                              class="btn btn-block btn-add"
                              type="submit"
                              :disabled="!company_id != ''"
                            >
                              Exportar em Excel
                              <i class="fas fa-file-export"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companies: [],
      company_id: "",
      hash: "kjsajg2582hkjnaInnovareTI@202022",
    };
  },
  methods: {
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getCompanies();
  },
  components: {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Report/Rooms.vue